import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DhdLoadingSpinnerComponent } from './dhd-loading-spinner.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  declarations: [DhdLoadingSpinnerComponent],
  exports: [DhdLoadingSpinnerComponent]

})
export class DhdLoadingSpinnerModule { }
